var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tarifas" }, [
    _c(
      "fieldset",
      {
        staticStyle: {
          width: "100%",
          "margin-bottom": "20px",
          display: "flex",
          height: "95%",
          border: "1px solid rgb(220, 220, 220)"
        }
      },
      [
        _c(
          "legend",
          {
            staticStyle: {
              "margin-left": "0.3rem",
              color: "#9e9e9e",
              "font-size": "0.8rem"
            }
          },
          [_vm._v("\n      Generar Reporte\n    ")]
        ),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              "align-items": "center",
              "justify-content": "center",
              width: "100%"
            }
          },
          [
            _c(
              "div",
              { staticStyle: { margin: "20px", width: "50%" } },
              [
                _c("v-autocomplete", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    items: _vm.flotas,
                    label: "Flotas",
                    multiple: "",
                    chips: "",
                    "deletable-chips": "",
                    dense: "",
                    "item-text": "__nom_flota",
                    "item-value": "cod_flota"
                  },
                  on: {
                    change: function($event) {
                      return _vm.confirmFlotas()
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "prepend-item",
                      fn: function() {
                        return [
                          _c(
                            "v-list-tile",
                            [
                              _c("v-checkbox", {
                                attrs: { label: "Seleccionar todos" },
                                on: {
                                  change: function($event) {
                                    _vm.selectAllFlota(), _vm.confirmFlotas()
                                  }
                                },
                                model: {
                                  value: _vm.checkAllFlotas,
                                  callback: function($$v) {
                                    _vm.checkAllFlotas = $$v
                                  },
                                  expression: "checkAllFlotas"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-divider")
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "selection",
                      fn: function(ref) {
                        var item = ref.item
                        var index = ref.index
                        return [
                          index === 0
                            ? _c("v-chip", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.textoComprimido(item.__nom_flota)
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          index === 1
                            ? _c(
                                "span",
                                {
                                  staticClass: "grey--text text-caption",
                                  staticStyle: { "font-size": "0.75em" }
                                },
                                [
                                  _vm._v(
                                    "\n              (+" +
                                      _vm._s(
                                        _vm.flotasSeleccionados.length - 1
                                      ) +
                                      ")\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.flotasSeleccionados,
                    callback: function($$v) {
                      _vm.flotasSeleccionados = $$v
                    },
                    expression: "flotasSeleccionados"
                  }
                })
              ],
              1
            ),
            _c("div", [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c(
                  "div",
                  { staticStyle: { margin: "20px" } },
                  [
                    _c("DatePicker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: { label: "Fecha Inicio", max: _vm.fechaMaxima },
                      model: {
                        value: _vm.fechaDesde,
                        callback: function($$v) {
                          _vm.fechaDesde = $$v
                        },
                        expression: "fechaDesde"
                      }
                    }),
                    _c("TimePicker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: { label: "Hora Inicio" },
                      model: {
                        value: _vm.horaDesde,
                        callback: function($$v) {
                          _vm.horaDesde = $$v
                        },
                        expression: "horaDesde"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { margin: "20px" } },
                  [
                    _c("DatePicker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: { label: "Fecha Fin", max: _vm.fechaMaxima },
                      model: {
                        value: _vm.fechaHasta,
                        callback: function($$v) {
                          _vm.fechaHasta = $$v
                        },
                        expression: "fechaHasta"
                      }
                    }),
                    _c("TimePicker", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: { label: "Hora Fin" },
                      model: {
                        value: _vm.horaHasta,
                        callback: function($$v) {
                          _vm.horaHasta = $$v
                        },
                        expression: "horaHasta"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "justify-content": "center" }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#FFE700" },
                          on: {
                            click: function($event) {
                              return _vm.buscaDashboard()
                            }
                          }
                        },
                        [_vm._v("Buscar")]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        )
      ]
    ),
    _c(
      "div",
      [
        _c(
          "v-layout",
          [
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "idCard" },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Top 5 Gastos Más Altos")
                      ])
                    ]),
                    _c("p", { staticClass: "titleCards" }, [
                      _vm._v("Total de Gastos: " + _vm._s(_vm.total))
                    ]),
                    _c("ag-grid-vue", {
                      staticClass: "ag-theme-material",
                      staticStyle: {
                        width: "100%",
                        height: "auto",
                        "font-family": "'Asap', sans-serif"
                      },
                      attrs: { gridOptions: _vm.gridOptions }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "idCard" },
                  [
                    _c(
                      "div",
                      { staticClass: "idcardTitle" },
                      [
                        _c("p", { staticClass: "titleCards" }, [
                          _vm._v("Cobros por Tipo de Tarifa")
                        ]),
                        _c("v-divider")
                      ],
                      1
                    ),
                    _c("doughnutComp", {
                      ref: "doughnutCompRef",
                      attrs: { height: 280 }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          { staticClass: "idCard" },
          [
            _c("div", { staticClass: "idcardTitle" }, [
              _c("p", { staticClass: "titleCards" }, [
                _vm._v("Gasto por Patente")
              ])
            ]),
            _c("barComp", { ref: "barRefSpeed", attrs: { height: 280 } })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }